import { render, staticRenderFns } from "./Huaquanzhuan.vue?vue&type=template&id=743568b8&"
import script from "./Huaquanzhuan.vue?vue&type=script&lang=js&"
export * from "./Huaquanzhuan.vue?vue&type=script&lang=js&"
import style0 from "./Huaquanzhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports